// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a8f6190","455":"d73f18dc","977":"57f08ed7"}[chunkId] + ".chunk.js";
};